import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  Box,
  SvgIcon,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { ReactComponent as hintBlub } from "../../../assets/images/hintBlub.svg";

import "./HintDialog.scss";

const HintPopup = ({ open, onClose, hints }) => {
  // Check if hints is an object with text and image properties
  // This handles both the new format (object with text/image) and old format (array of strings)
  const hintText = Array.isArray(hints) ? hints : hints?.text || [];
  const hintImage = !Array.isArray(hints) ? hints?.image : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: "hint-popup" }}
      maxWidth="md"
      disableEnforceFocus
      slotProps={{
        backdrop: {
          className: "custom-backdrop-hint",
        },
      }}
    >
      <Box>
        <DialogActions className="hint-actions">
          <IconButton className="close-button" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogActions>

        <DialogContent dividers className="hint-content">
          <Stack justifyContent={"center"} alignItems="center">
            <SvgIcon
              component={hintBlub}
              className="hint-icon"
              inheritViewBox
            />
            <p className="title">{`Hint`}</p>

            {hintText.map((hint, index) => (
              <React.Fragment key={index}>
                <p className="hint-text">{hint}</p>
                {/* Place the image after the second hint item */}
                {index === 0 && hintImage && (
                  <Box className="hint-image-container">
                    <img
                      src={hintImage}
                      alt="Hint Diagram"
                      className="hint-diagram"
                      style={{ maxWidth: "100%", borderRadius: "4px" }}
                    />
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Stack>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default HintPopup;
